export const simulationFullPage = '/fulfillment-reports/simulation-report';
